import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Alert, AlertTitle } from "@mui/material";

const NoRecordMessage = (props) => {
  const { isEmpty, title, message, onClickLink, textLink } = props;

  return (
    <>
      {isEmpty && (
        <Alert severity="info" className="mt-3 mb-3">
          <AlertTitle>{title && title}</AlertTitle>
          {message && <span>{message}</span>}{" "}
          <strong>
            {textLink && (
              <a onClick={onClickLink} className="text--link">
                {textLink}
              </a>
            )}
          </strong>
        </Alert>
      )}
    </>
  );
};

export default NoRecordMessage;
